import React, { PropsWithChildren, useEffect } from 'react';
import { LoadingSpinner } from '@sato/components';
import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';

import { taskStore } from '@stores/taskStore';

/** Component indicating loading state on top of the entire
 * application when loader mobx state has queued processes */
export const PageLoaderContainer = observer(
  ({ children, className }: PropsWithChildren<{ className?: string }>) => {
    const isLoading = !taskStore.isReady;

    useEffect(() => {
      // if loader is active, prevent page scrolling
      document.body.style.overflowY = isLoading ? 'hidden' : 'auto';
    }, [isLoading]);

    return (
      <>
        <div
          className={twMerge(
            // blur screen when loader queue has unfinished processes
            isLoading && 'blur-sm',
            className
          )}
        >
          {children}
        </div>

        {isLoading && (
          <div className="fixed left-1/2 top-1/2 mx-auto -translate-x-1/2 -translate-y-1/2 ">
            <LoadingSpinner
              data-testid="global-loading-indicator"
              size={48}
              className="text-brand-interactive-dark"
            />
          </div>
        )}
      </>
    );
  }
);
